import React from 'react';

import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';
import ErrorWrapper from 'dpl/form/components/ErrorWrapper';
import useFormContext from 'dpl/shared/form/hooks/useFormContext';
import { get } from 'dpl/shared/utils/object';

import { FORM_ACCOUNT_PASSWORD } from '../utils/constants';
import useInitialInquiry from '../hooks/useInitialInquiry';

export default function QuizPasswordQuestion(props) {
  const { breederProfile } = useInitialInquiry();

  const { name: programName } = breederProfile;
  const { formState, formErrors, handleFormFieldChange } = useFormContext();

  const password = get(formState, FORM_ACCOUNT_PASSWORD, '');

  return (
    <FullPageQuizQuestion
      className="InitialInquiryQuizPasswordQuestion"
      title="Enter a password to finish creating your Good Dog account — and youʼre done!"
      subtitle={`Once you create an account, ${programName} will receive your request and you’ll be able to start chatting with them.`}
      icon="lock"
      newDesignSystemStyles
      {...props}
    >
      <ErrorWrapper errors={formErrors[FORM_ACCOUNT_PASSWORD]}>
        <FullPageQuizTextInput
          type="password"
          className="mb1"
          id={FORM_ACCOUNT_PASSWORD}
          name={FORM_ACCOUNT_PASSWORD}
          placeholder="6+ characters"
          value={password}
          onChange={handleFormFieldChange}
          labelText="Password"
          newDesignSystemStyles
        />
      </ErrorWrapper>
    </FullPageQuizQuestion>
  );
}
